const KEY = "ir_ref";
const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

export const storeRef = (code) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, exp: Date.now() + THIRTY_DAYS }));
  } catch { /* ignore */ }
};

export const getRef = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, exp } = JSON.parse(raw);
    if (Date.now() > exp) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
};

export const refLink = (code) => (code ? `${window.location.origin}/?ref=${code}` : "");
